export default "__VITE_ASSET__nwAaOdhy__"